import Enumerable from "linq";

export class ArrayUtilities {
  static createNewArray<T>(count: number, defaultValue: T): T[] {
    return Enumerable.range(0, count)
      .select(i => defaultValue)
      .toArray();
  }

  static createNew2dArray<T>(row: number, column: number, defaultValue: T): T[][] {
    return Enumerable.range(0, row)
      .select(i => ArrayUtilities.createNewArray(column, defaultValue))
      .toArray();
  }
}
